var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83758 4.52109L2.94586 1.7002",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2834 8.10823V3.76003C10.2832 3.5694 10.2329 3.38218 10.1375 3.21714C10.0421 3.0521 9.905 2.91505 9.73992 2.81973L5.93524 0.645637C5.76999 0.550228 5.58254 0.5 5.39172 0.5C5.2009 0.5 5.01345 0.550228 4.8482 0.645637L1.04352 2.81973C0.878436 2.91505 0.741314 3.0521 0.645915 3.21714C0.550517 3.38218 0.500196 3.5694 0.5 3.76003V8.10823C0.500196 8.29886 0.550517 8.48608 0.645915 8.65112C0.741314 8.81616 0.878436 8.95321 1.04352 9.04852L4.8482 11.2226C5.01345 11.318 5.2009 11.3683 5.39172 11.3683C5.58254 11.3683 5.76999 11.318 5.93524 11.2226L9.73992 9.04852C9.905 8.95321 10.0421 8.81616 10.1375 8.65112C10.2329 8.48608 10.2832 8.29886 10.2834 8.10823Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.64679 3.19482L5.39176 5.93962L10.1367 3.19482",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39172 11.4128V5.93408",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup15);
export default __webpack_public_path__ + "static/media/Group 15.384421dc5ecaf9ad4fe1c7639f5aae4c.svg";
export { ForwardRef as ReactComponent };